<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
          v-divider
          AdminEditIM(:title='title' :dialogType='dialogType')
</template>

<script>
import * as config from "../config/index.json";
import AdminEditIM from "@/components/AdminEditIM.vue";
import PermitModal from "@/components/PermitModal.vue";
import { mapState } from "vuex";
import helper from "../helper/index.js";

export default {
  name: "AdminEdit",
  components: {
    AdminEditIM,
    PermitModal
  },
  data () {
    return {
      config: config.default,
      title: 'List Permit',
      dialogType: 'creator',     
    }
  },
  computed: {
    ...mapState(["listPermit","listPermitByIpNo"])
  },
  methods: {
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate
  }
};
</script>
